import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import trErrors from '../locales/tr-TR/errors.json';
import authTR from '../locales/tr-TR/auth.json';
import marketplaceTR from '../locales/tr-TR/marketplace.json';
import enUSErrors from '../locales/en-US/errors.json';
import authUS from '../locales/en-US/auth.json';
import marketplaceUS from '../locales/en-US/marketplace.json';
import enGBErrors from '../locales/en-GB/errors.json';
import authGB from '../locales/en-GB/auth.json';
import marketplaceGB from '../locales/en-GB/marketplace.json';
import dashboardTR from '../locales/tr-TR/dashboard.json';
import dashboardUS from '../locales/en-US/dashboard.json';
import dashboardGB from '../locales/en-GB/dashboard.json';
import adminTR from '../locales/tr-TR/admin.json';
import adminUS from '../locales/en-US/admin.json';
import sellTR from '../locales/tr-TR/sell.json';
import sellUS from '../locales/en-US/sell.json';
import sellGB from '../locales/en-GB/sell.json';
import supportTR from '../locales/tr-TR/support.json';
import supportUS from '../locales/en-US/support.json';
import supportGB from '../locales/en-GB/support.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en-US',
        defaultNS: 'common',
        ns: [
            'common',
            'auth',
            'marketplace',
            'dashboard',
            'admin',
            'sell',
            'legal',
            'errors',
            'validation',
            'notifications',
            'support'
        ],

        resources: {
            'tr-TR': {
                errors: trErrors.errors,
                auth: authTR.auth,
                marketplace: marketplaceTR.marketplace,
                dashboard: dashboardTR,
                admin: adminTR,
                sell: sellTR,
                support: supportTR
            },
            'en-US': {
                errors: enUSErrors.errors,
                auth: authUS.auth,
                marketplace: marketplaceUS.marketplace,
                dashboard: dashboardUS,
                admin: adminUS,
                sell: sellUS,
                support: supportUS
            },
            'en-GB': {
                errors: enGBErrors.errors,
                auth: authGB.auth,
                marketplace: marketplaceGB.marketplace,
                dashboard: dashboardGB,
                sell: sellGB,
                support: supportGB
            }
        },

        interpolation: {
            escapeValue: false
        },

        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'fct_language'
        },

        react: {
            useSuspense: false
        },

        debug: false,
        nsSeparator: ':',
        keySeparator: '.'
    });

export default i18n;
